.width {
  width: 398px;
}

.padding {
  padding: 5px 6px;
  word-wrap: break-word;
}
